// extracted by mini-css-extract-plugin
var _1 = "avRmL";
export { _1 as "productPicker" }
